/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class t{static getStorageSpec(t){return null}static createOrUpdateRendererSchema(t,e){return null!=t&&"default"===t.type?t:{type:"default"}}static getVariation(t){return{}}static getVariationHash(t){return 0}}t.type="default",t.programSpec=null;export{t as Technique};
